export const sort = (list, sortBy, isDesc) => list.sort((a, b) => {
  const nameA = getLowerCase(a[sortBy]);
  const nameB = getLowerCase(b[sortBy]);
  if (nameA === nameB) {
    return 0;
  }

  const sortDirectionValue = isDesc ? -1 : 1;
  return (nameA > nameB) ? sortDirectionValue : -sortDirectionValue;
});


const getLowerCase = input => typeof input === 'string' ? input.toLowerCase() : input;
